import {
    GET_WORKSHOP_LEVEL_RECIPES_LOADING,
    GET_WORKSHOP_LEVEL_RECIPES_SUCCESS,
    GET_WORKSHOP_LEVEL_RECIPES_FAILURE
} from '../actionTypes'
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';

import { client } from '../../services/client';
import { getRecursivelyAsync } from '../../utils/get-recursively-async';

export const getWorkshopLevelRecipesSuccess = payload => ({
    type: GET_WORKSHOP_LEVEL_RECIPES_SUCCESS,
    payload
})

export const getWorkshopLevelRecipesFailure = () => ({
    type: GET_WORKSHOP_LEVEL_RECIPES_FAILURE
})

export const getWorkshopLevelRecipesAsync = payload => dispatch => {
    return dispatch(getRecursivelyAsync('workshop-level-recipes', getWorkshopLevelRecipesSuccess, 0));
}